import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip, Button, Spinner, Badge } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService";

import IndexBloc from "../Blocs/IndexBlock";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";
import moment from "moment";
const formatDateWithTime = (value) => {
  if (value != "-") {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "short" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });
    const time = date.toLocaleTimeString("id-ID");

    return day + " " + month + " " + year + " " + time;
  } else {
    return value;
  }
};
class TableUangMakanComponent extends Component {
  indexBloc = new IndexBloc();

  userdata = JSON.parse(localStorage.getItem("userdata"));

  source;
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: false,
      cancelDate: null,
      rows: [],
      filteredRows: [],
      searchQuery: "",
      statusFilter: "",
      is_verif: 0,
      pending_approval_cuti: 0,
      verification: null,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi uang makan?",
      employee_nip: null,
    };
  }

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  getStatusText = (row) => {
    if (row && row.presensi_summary_status_penugasan) {
      const raw = String(row.presensi_summary_status_penugasan);
      const beforeBr = raw.split(/<br[\s/]*>|\n/i)[0];
      const s = beforeBr.replace(/<[^>]*>?/gm, "").trim();
      if (s && s !== "-") return s;
    }
    const isPay = row?.presensi_summary_is_pay_uangmakan == 1;
    return isPay ? "Dibayar" : "Belum Dibayar";
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ searchQuery: value }, () => {
      this.filterRows();
    });
  };

  handleStatusChange = (e) => {
    const value = e.target.value;
    this.setState({ statusFilter: value }, () => {
      this.filterRows();
    });
  };

  filterRows = () => {
    const query = (this.state.searchQuery || "").trim().toLowerCase();
    const statusFilter = (this.state.statusFilter || "").trim();

    const filtered = (this.state.rows || []).filter((row) => {
      if (query) {
        const nip = String(row.presensi_summary_employee_nip || "").toLowerCase();
        const name = String(row.employee_full_name || "").toLowerCase();
        if (!nip.includes(query) && !name.includes(query)) {
          return false;
        }
      }

      if (statusFilter) {
        const rowStatus = this.getStatusText(row);
        if (rowStatus !== statusFilter) {
          return false;
        }
      }

      return true;
    });

    this.setState({ filteredRows: filtered });
  };

  // loadData = async () => {
  //     this.setState({ loadingTable: true })
  //     var additionalFilter = this.props.additionalFilter
  //     this.indexBloc.fetchListUangMakan({ ...additionalFilter });
  // }

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
  };
  getListUangMakan = async () => {
    this.setState({ loadingTable: true });
    var additionalFilter = this.props.additionalFilter;
    this.indexBloc.fetchListUangMakan({ ...additionalFilter });
  };
  handleButtonGenerateUangMakan() {
    this.indexBloc.setGenerate({
      tipe: 3,
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      generate_verification_by_nip: this.userdata?.employee_nip,
      generate_verification_by_fullname: this.userdata?.employee_full_name,
    });
  }
  handleButtonExportUangMakan = () => {
    this.indexBloc.fetchExportUangMakan({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };
  handleButtonExportUangMakanTxt = () => {
    this.indexBloc.fetchExportUangMakanTxt({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };
  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        if (this.state.runType == 1) {
          this.submitVerification();
        }

        if (this.state.runType == 2) {
          this.syncData();
        }
        if (this.state.runType == 5) {
          this.handleButtonGenerateUangMakan();
        }
        if (this.state.runType == 10) {
          this.openVerification();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  handleButtonExportUangMakan = () => {
    this.indexBloc.fetchExportUangMakan({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };
  handleButtonExportUangMakanTxt = () => {
    this.indexBloc.fetchExportUangMakanTxt({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };
  checkVerification() {
    this.indexBloc.fetchCheck({
      year: this.props.additionalFilter.year,
      month: this.props.additionalFilter.month,
      type: 3, // UANG MAKAN
    });
  }

  submitVerification = async () => {
    await this.indexBloc.fetchVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      type: 3, // UANG MAKAN
    });
  };
  openVerification = async () => {
    await this.indexBloc.openVerification({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
      description: this.userdata?.employee_full_name,
      nip: this.userdata?.employee_nip,
      type: 3, // tunkin
    });
  };
  syncData = async () => {
    let additionalFilter = this.props.additionalFilter;

    await this.indexBloc.fetchSync({
      employee_nip: this.state.employee_nip,
      type: 'uang_makan',
      ...additionalFilter,
    });
  };
  fixMinioUrl = (brokenUrl) => {
    // 1. Decode sekali
    let once = decodeURIComponent(brokenUrl);

    // 2. Ambil hanya URL dari "https://" kedua
    const idx = once.indexOf("https://", 8);
    if (idx !== -1) {
      once = once.substring(idx);
    }

    // 3. Ambil hanya satu set query params
    const q1 = once.indexOf("?");
    const q2 = once.indexOf("?", q1 + 1);
    if (q1 !== -1 && q2 !== -1) {
      once = once.substring(0, q2);
    }

    return once;
  };
  componentDidMount() {
    // this.setTokenAPI()

    this.indexBloc.listUangMakanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
            rows: [],
            filteredRows: [],
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          const rows = response.result || [];
          this.setState(
            {
              rows,
              loadingTable: false,
            },
            () => {
              this.filterRows();
            }
          );
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.indexBloc.openverificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.indexBloc.exportUangMakanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          if (link?.file_url.url_encoded) {
            const fixedUrl = this.fixMinioUrl(link.file_url.url_encoded);
            window.open(fixedUrl, "_blank");
          } else {
            console.log("file_url", link.file_url);
            window.open(link.file_url, "_blank");
          }
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
    this.indexBloc.exportUangMakanTxtChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
    // this.indexBloc.checkChannel.subscribe((result) => {
    //     switch (result.status) {
    //         case apiResponse.LOADING:
    //             this.setState({
    //                 loadingCurrent: true
    //             });
    //             break
    //         case apiResponse.COMPLETED:
    //             if (result.data.status) {
    //                 let response = result.data.response
    //                 if (response.check_result != null) {
    //                     this.setState({
    //                         is_verif: 1,
    //                         verification: response.check_result,
    //                         pending_approval_cuti: response.pending_approval_cuti
    //                     })
    //                 } else {
    //                     this.setState({
    //                         is_verif: 0,
    //                         verification: response.check_result,
    //                         pending_approval_cuti: response.pending_approval_cuti
    //                     })
    //                 }
    //             }
    //             break
    //         case apiResponse.ERROR:

    //             break
    //         default:
    //             break
    //     }
    // })

    //this.checkVerification()

    this.indexBloc.verificationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          this.props.handleCheckGenerateSuccess();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.syncChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              // this.props.handleInactiveSuccess()
            },
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.listUangMakanChannel?.unsubscribe();
    this.indexBloc.exportTunkinChannel?.unsubscribe();
    //this.indexBloc.checkChannel?.unsubscribe()
    this.indexBloc.verificationChannel?.unsubscribe();
    this.indexBloc.syncChannel?.unsubscribe();
  }

  render() {
    const uniqueStatuses = Array.from(
      new Set(
        (this.state.rows || [])
          .map((row) => this.getStatusText(row))
          .filter((s) => s !== "")
      )
    ).sort();

    return (
      <>
        {/* BAGIAN STATUS VERIFIKASI (Banner) */}
        <div className="mb-4">
          {this.props.additionalFilter.verification_data_is_verif_uangmakan ===
            0 ? (
            <div
              className="alert alert-danger d-flex align-items-center py-2 m-0 shadow-sm"
              style={{ fontSize: "0.85rem" }}
            >
              <i className="uil uil-info-circle fs-5 me-2"></i>
              <span>
                Status Verifikasi Uang Makan Periode{" "}
                <strong>
                  {this.props.additionalFilter.month_name}{" "}
                  {this.props.additionalFilter.year}
                </strong>{" "}
                : <strong>Belum Dilakukan Verifikasi</strong>
              </span>
            </div>
          ) : this.props.additionalFilter
            .verification_data_is_verif_uangmakan === 1 ? (
            <div
              className="alert alert-success d-flex align-items-center py-2 m-0 shadow-sm"
              style={{ fontSize: "0.85rem" }}
            >
              <i className="uil uil-check-circle fs-5 me-2"></i>
              <span>
                Telah dilakukan Verifikasi Uang Makan Periode{" "}
                <strong>
                  {this.props.additionalFilter.month_name}{" "}
                  {this.props.additionalFilter.year}
                </strong>{" "}
                oleh{" "}
                <strong>
                  {
                    this.props.additionalFilter
                      .verification_data_description_uangmakan
                  }
                </strong>{" "}
                pada{" "}
                {formatDateWithTime(
                  this.props.additionalFilter
                    .verification_data_created_date_uangmakan,
                )}
              </span>
            </div>
          ) : null}
        </div>

        {/* BAGIAN TOMBOL AKSI */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Tombol Kiri */}
          <div>
            <Button
              color="success"
              size="sm"
              className="me-2 shadow-sm"
              onClick={() => {
                this.setState({
                  confirm: true,
                  runType: 5,
                  confirmInfo:
                    "Apakah anda yakin akan melakukan proses Generate Ulang?",
                });
              }}
              disabled={this.props.additionalFilter.is_generate_uangmakan == 0}
            >
              <i className="uil-refresh me-1"></i>
              {this.props.additionalFilter.is_pay_uangmakan == 1
                ? `Uang Makan Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year} telah dibayarkan`
                : this.props.additionalFilter
                  .generate_verification_status_uangmakan == 0
                  ? `Proses Generate Uang Makan oleh: ${this.props.additionalFilter.generate_verification_by_fullname_uangmakan}`
                  : this.props.additionalFilter
                    .generate_verification_status_uangmakan == 1
                    ? `Generate Ulang Uang Makan (Last: ${this.props.additionalFilter.generate_verification_start_date_uangmakan} oleh ${this.props.additionalFilter.generate_verification_by_fullname_uangmakan})`
                    : `Generate Ulang Uang Makan Periode ${this.props.additionalFilter.month_name} ${this.props.additionalFilter.year}`}
            </Button>
            <Button
              color="danger"
              outline
              size="sm"
              className="shadow-sm"
              onClick={() =>
                this.setState({
                  confirm: true,
                  runType: 10,
                  confirmInfo:
                    "Apakah anda yakin akan membuka ulang hasil verifikasi Uang Makan?",
                })
              }
              style={{
                display:
                  this.props.additionalFilter
                    .verification_data_is_verif_uangmakan == 1 &&
                    ["198501292014031001", "198903092012121002", "199508012025212056"].includes(this.userdata?.employee_nip)
                    ? "inline-block"
                    : "none",
              }}
            >
              <i className="uil uil-lock-open-alt me-1"></i> Buka Verifikasi
            </Button>
          </div>

          {/* Tombol Kanan */}
          <div className="d-flex align-items-center">
            <Button
              color="warning"
              outline
              size="sm"
              className="me-2 shadow-sm border-warning text-dark"
              onClick={() => {
                this.handleButtonExportUangMakan();
              }}
            >
              <i className="uil-file-download me-1"></i> Export Xls
            </Button>
            <Button
              color="primary"
              size="sm"
              className="shadow-sm fw-bold"
              onClick={() =>
                this.setState({
                  confirm: true,
                  runType: 1,
                  confirmInfo:
                    "Apakah anda yakin akan melakukan verifikasi Uang Makan?",
                })
              }
              disabled={
                this.props.additionalFilter
                  .verification_data_is_verif_uangmakan == 1
              }
            >
              <i className="uil uil-check-circle me-1"></i> Verifikasi Uang
              Makan
            </Button>
          </div>
        </div>

        <div className="d-flex flex-wrap gap-2 mb-3 align-items-center">
          <div className="input-group me-2" style={{ maxWidth: "340px" }}>
            <span className="input-group-text">
              <i className="uil uil-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Pencarian Berdasarkan NIP dan Nama"
              value={this.state.searchQuery || ""}
              onChange={this.handleSearchChange}
            />
          </div>

          <div style={{ minWidth: "180px" }}>
            <select
              className="form-select form-control"
              value={this.state.statusFilter || ""}
              onChange={this.handleStatusChange}
            >
              <option value="">Semua Status</option>
              {uniqueStatuses.map((s, idx) => (
                <option key={idx} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>
        </div>

        <style>{`
          .sticky-header-table thead th {
            box-shadow: inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3 !important;
          }
        `}</style>
        <div
          className="table-responsive"
          style={{ maxHeight: "75vh", overflowX: "auto", overflowY: "auto" }}
        >
          <Table
            className="table table-striped table-bordered sticky-header-table"
            style={{ minWidth: "1400px" }}
          >
            <thead
              className="table-primary"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                backgroundColor: "#e9ecef",
              }}
            >
              <tr>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "50px",
                    minWidth: "50px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: 0,
                    zIndex: 4,
                  }}
                  rowSpan="3"
                >
                  No
                </th>
                <th
                  className="text-center align-middle"
                  style={{
                    width: "250px",
                    minWidth: "250px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                    boxShadow: "inset -1px 0 0 #c8cce1, inset 0 -1px 0 #b9bfd3",
                    position: "sticky",
                    left: "50px",
                    zIndex: 4,
                  }}
                  rowSpan="3"
                >
                  NIP <br />
                  Nama
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    fontWeight: 600,
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="7"
                >
                  Bulan Sebelumnya
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    fontWeight: 600,
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="8"
                >
                  Sekarang
                </th>
              </tr>
              <tr>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  rowSpan="2"
                >
                  Pangkat/Golongan
                </th>

                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Jumlah Kehadiran
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="4"
                >
                  Jumlah Ketidakhadiran
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  rowSpan={2}
                >
                  Hukuman Disiplin
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  rowSpan="2"
                >
                  Pangkat/Golongan
                </th>

                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Jumlah Kehadiran
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  colSpan="4"
                >
                  Jumlah Ketidakhadiran
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  rowSpan="2"
                >
                  Hukuman Disiplin
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                  rowSpan="2"
                >
                  Status Bayar
                </th>
              </tr>
              <tr>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Hadir
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Alpha
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Cuti
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Dinas
                </th>
                <th
                  className="text-center align-middle table-warning"
                  style={{
                    backgroundColor: "#fff7d6",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Tugas Belajar / CLTN / Ditugaskan Diinstansi Lain / IIPC
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Hadir
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Alpha
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Cuti
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Dinas
                </th>
                <th
                  className="text-center align-middle table-success"
                  style={{
                    backgroundColor: "#e8f8ea",
                    border: "1px solid #c8cce1",
                    borderBottom: "1px solid #b9bfd3",
                  }}
                  width="*"
                >
                  Tugas Belajar / CLTN / Ditugaskan Diinstansi Lain / IIPC
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingTable == false ? (
                (this.state.filteredRows || []).length > 0 ? (
                  (this.state.filteredRows || []).map((data, index) => {
                    return (
                      <tr
                        id={"tr_uangmakan_" + index}
                        style={{ border: "1px solid #c8cce1" }}
                        key={index}
                      >
                        <td
                          className="text-center"
                          style={{
                            borderColor: "#c8cce1",
                            boxShadow: "inset -1px 0 0 #c8cce1",
                            position: "sticky",
                            left: 0,
                            backgroundColor: "#ffffff",
                            zIndex: 2,
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            borderColor: "#c8cce1",
                            boxShadow: "inset -1px 0 0 #c8cce1",
                            position: "sticky",
                            left: "50px",
                            backgroundColor: "#ffffff",
                            zIndex: 2,
                          }}
                        >
                          <b>{data.presensi_summary_employee_nip}</b> <br />{" "}
                          {data.employee_full_name} <br />
                          <br />
                          <small>
                            {
                              data.presensi_summary_employee_categories_name_full
                            }
                          </small>
                          <br /> <br />
                          <Button
                            outline
                            color="primary"
                            className="btn-sm"
                            onClick={() =>
                              this.setState({
                                confirm: true,
                                runType: 2,
                                employee_nip:
                                  data.presensi_summary_employee_nip,
                                confirmInfo:
                                  "Apakah anda yakin akan melakukan kalkulasi ulang untuk data " +
                                  data.employee_full_name +
                                  " ?",
                              })
                            }
                          >
                            <i className="uil-refresh"></i> Kalkulasi Ulang
                          </Button>
                        </td>

                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_emp_rank_group_room}
                        </td>

                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_total_hadir}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_total_alpha}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_total_cuti}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_total_dinas}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_old_total_tugas_belajar}
                        </td>
                        <td
                          className="text-center table-warning"
                          style={{ backgroundColor: "rgb(255, 250, 233)" }}
                        >
                          {data.presensi_summary_tunkin_old_punishment}
                        </td>

                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_emp_rank_group_room}
                        </td>

                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_total_hadir}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_total_alpha}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_total_cuti}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_total_dinas}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_total_tugas_belajar}
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {
                            data.presensi_summary_presentase_punishment_discipline
                          }
                        </td>
                        <td
                          className="text-center table-success"
                          style={{ backgroundColor: "#e6ffe5" }}
                        >
                          {data.presensi_summary_is_pay_uangmakan == 1 ? (
                            <i className="fas fa-check text-success"></i>
                          ) : (
                            <i className="fas fa-times text-danger"></i>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr style={{ border: "1px solid #c8cce1" }}>
                    <td colSpan="19" className="text-center">
                      Tidak Ada Data
                    </td>
                  </tr>
                )
              ) : (
                <tr style={{ border: "1px solid #c8cce1" }}>
                  <td colSpan="19" className="text-center">
                    <Spinner className="m-2" color="primary" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengambil data"
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil diproses"
            failedTitle="Gagal!"
            failedInfo="Data gagal diproses"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
        </div>
      </>
    );
  }
}

export default TableUangMakanComponent;
